import { render, staticRenderFns } from "./InformeTotal.vue?vue&type=template&id=27b9f220&"
import script from "./InformeTotal.vue?vue&type=script&lang=js&"
export * from "./InformeTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports